import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useBOMProjectStore } from "../../../hooks/bom_project";
import System from "../../../helper/system";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const BomDeleteProjectPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ BomDeleteProjectPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ }, { fetch_bom_project_detail_with_bom }, { delete_project }] = useBOMProjectStore();
    useEffect(() => {
        if (BomDeleteProjectPopup) {
            SetStatus(true)
        }
    }, [BomDeleteProjectPopup]);
    const onHide = (action = true) => {
        SetStatus(false)
    };
    const onDeleteProject = async () => {
        let projectId = BomDeleteProjectPopup && BomDeleteProjectPopup.data && BomDeleteProjectPopup.data.projectId
        await delete_project({ projectId });
        onHide()
        await fetch_bom_project_detail_with_bom();
        System.alert('Your BOM Project ' + `${BomDeleteProjectPopup && props.data && props.data.projectName}` + ' has been deleted');
    };

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>

                <div className="avnet-modal modal-730">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header border-0">
                            <h3 className="modal-title text-center m-auto" id="exampleModalLabel">Are you sure you want to
                                delete this project?</h3>
                        </div>
                        <div className="modal-body">
                            <div className="mt-4 mb-5 text-center"><b className='font-14'>This will also delete all the BOMs it contains.</b></div>
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary w145"
                                onClick={() => {
                                    onHide()
                                }}>cancel
                            </button>
                            <button type="button" className="bs5 btn btn-primary  w145"
                                onClick={() => onDeleteProject()}>delete project
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default BomDeleteProjectPopup;